var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { deepMix } from '@antv/util';
import { column } from './utils/helper';
/**
 * Infer key for every element.
 */
export var MaybeKey = function MaybeKey() {
  return function (I, mark) {
    var encode = mark.encode;
    var key = encode.key,
      rest = __rest(encode, ["key"]);
    if (key !== undefined) return [I, mark];
    var values = Object.values(rest).map(function (_ref) {
      var value = _ref.value;
      return value;
    });
    var K = I.map(function (i) {
      return values.filter(Array.isArray).map(function (V) {
        return V[i];
      }).join('-');
    });
    return [I, deepMix({}, mark, {
      encode: {
        key: column(K)
      }
    })];
  };
};
MaybeKey.props = {};